export const defaultCorpus = {
  en: {
    CloseButton: {
      ariaCloseButtonLabel: 'Close',
    },
    EmailForm: {
      defaultSubmitButtonLabel: 'Get started',
      defaultEmailFieldPlaceholder: 'Your email address',
    },
    LocalePicker: {
      ariaPrompt: 'Select Language',
    },
    NewSticker: {
      newText: 'New',
    },
    PricingAddons: {
      tryButtonLabel: 'Try for Free',
      chatButtonLabel: 'Chat with Us',
    },
    PricingTierCard: {
      howWeCalculatePrice: 'How we calculate price',
      customPricing: 'Custom pricing',
    },
    HeaderNav: {
      ctaButtonLabel: 'Get started',
    },
    BenefitCalculator: {
      benefitsHeader: 'You can expect:',
    },
    SolutionFeaturesModal: {
      customPricing: 'Custom pricing',
    },
    SolutionWithTiers: {
      fullFeatures: 'See full feature comparisons',
      recommendedTier: '68% of businesses choose Pro',
    },
  },
}
